// actions/types/notificationActionTypes.js
export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

export const MARK_NOTIFICATION_READ_REQUEST = "MARK_NOTIFICATION_READ_REQUEST";
export const MARK_NOTIFICATION_READ_SUCCESS = "MARK_NOTIFICATION_READ_SUCCESS";
export const MARK_NOTIFICATION_READ_FAILURE = "MARK_NOTIFICATION_READ_FAILURE";

export const MARK_ALL_NOTIFICATIONS_READ_REQUEST = "MARK_ALL_NOTIFICATIONS_READ_REQUEST";
export const MARK_ALL_NOTIFICATIONS_READ_SUCCESS = "MARK_ALL_NOTIFICATIONS_READ_SUCCESS";
export const MARK_ALL_NOTIFICATIONS_READ_FAILURE = "MARK_ALL_NOTIFICATIONS_READ_FAILURE";

export const DELETE_NOTIFICATION_REQUEST = "DELETE_NOTIFICATION_REQUEST";
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCCESS";
export const DELETE_NOTIFICATION_FAILURE = "DELETE_NOTIFICATION_FAILURE";

export const GET_NOTIFICATION_STATS_REQUEST = "GET_NOTIFICATION_STATS_REQUEST";
export const GET_NOTIFICATION_STATS_SUCCESS = "GET_NOTIFICATION_STATS_SUCCESS";
export const GET_NOTIFICATION_STATS_FAILURE = "GET_NOTIFICATION_STATS_FAILURE";

export const ADD_NEW_NOTIFICATION = "ADD_NEW_NOTIFICATION";
export const UPDATE_NOTIFICATION_COUNT = "UPDATE_NOTIFICATION_COUNT";